<template>
    <fragment>
        <div class="modalCards mb-3">
            <div @click="putWay(data)" v-for="data in ways" :key="data.id" class="custom-modal__select-card-wrapper"
             :class="data.id == way.id ? 'custom-modal__select-card-wrapper--selected' : ''">
            <div
                class="custom-modal__select-card-container py-3 position-relative h-100 position-relative"
                :class="{ 'has-tooltip': data.id === 'flash' }"
                @click="data.id === 'flash' ? showTooltip = true : showTooltip = false"
            >
               <div class="custom_tooltip bg_green rounded p-3 position-absolute z-4" v-if="showTooltip && data.id === 'flash'" @click.stop="showTooltip = false">
                Выплата по номеру карты приходит за 1-5 минут. Доступны выплаты только по номеру карт банков РФ.
               </div>
             <div class="d-flex flex-column gap-2 align-items-center w-100">
               <img
                 v-if="data.id === 'flash'"
                 class="position-absolute"
                 style="top:5px; right:5px"
                 src="/img/ico/required.svg"
               >
               <img
                 class="custom-modal__select-card-ico"
                 :src="data.id == way.id ? data.imgrev : data.img"
                 style="object-fit: contain;"
               />
               <span class="text-center">{{ data.title }}</span>
             </div>
           </div>
            </div>
        </div>
    </fragment>
</template>

<script>
export default {
    props: ['ways', 'way'],
    data() {
        return {
            showTooltip: false
        }
    },
    methods: {
        putWay(data) {
            this.$emit("update:way", data);
        },
        initMethodIfNeeded(ways) {
            if (!this.way && ways.length) {
                this.putWay(ways[0]);
            }
        },
    },
    computed: {
        isSpecMode() {
            return !!this.$route?.query?.spec;
        },
        visibleWays() {
            return this.isSpecMode ? this.ways : this.ways.filter(item => item.id !== 'flash');
        }
    },

    watch: {
        ways: {
            deep: true,
            handler(newVal) {
                this.initMethodIfNeeded(newVal);
            }
        },
        method: {
            immediate: true,
            handler() {
                this.initMethodIfNeeded(this.ways);
            }
        },
    }
}
</script>

<style scoped>
.modalCards {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(4, 1fr);
}

.custom-modal__select-card-container {
    background-color: #fff;
    color: #212121;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    height: auto;
}

.custom-modal__select-card-wrapper--selected .custom-modal__select-card-container {
    background-color: #4AA485;
    position: relative;
    color: #fff;
}

.custom-modal__select-card-wrapper--selected .custom-modal__select-card-container:before {
    display: none;
}

.custom_tooltip {
    bottom: 100%;           /* разместить над родительским элементом */
    margin-bottom: 15px;     /* расстояние в 5px от элемента */
    left: 50%;
    transform: translateX(-50%);
    width: 204px;
    background-color: #4AA485;
    display: flex;
    justify-content: center;
    position: absolute;
    z-index: 99;
  }

.custom_tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 10px;
    border-style: solid;
    border-color: #4AA485 transparent transparent transparent; /* Цвет совпадает с тултипом */
  }

@media(max-width:992px) {
    .modalCards {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media(max-width:428px) {
    .modalCards {
        grid-template-columns: repeat(1, 1fr);
    }
}

</style>


